import React from 'react';

function ProfileCompleteMessage({ isCompleted }) {
  return !isCompleted ? <h4 className="mt-30">Few steps are missing to get better results:</h4> : <></>;
}

export default ProfileCompleteMessage;
